import { Instagram, Heart } from "lucide-react";
import { GALLERY, BUSINESS } from "@/data/salonData";
import { Reveal } from "@/lib/useReveal";

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-20 md:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal className="text-center max-w-3xl mx-auto">
          <span className="heading-flourish">Our Work</span>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#2a1b18] font-medium mt-4 leading-tight">
            A Glimpse Into <span className="text-gradient-rose italic">Anshi's</span>{" "}
            <span className="text-gradient-gold italic">Artistry</span>
          </h2>
          <p className="mt-5 text-[#5c4642] text-base md:text-lg">
            Real brides, real moments, real glow. Every photo tells a story
            of a woman who walked in nervous and walked out radiant.
          </p>
          <a
            href={BUSINESS.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="gallery-instagram-link"
            className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-gradient-to-r from-[#fff0f5] to-[#f9d0da] text-[#b56477] text-sm font-medium hover:shadow-md transition-shadow"
          >
            <Instagram size={16} /> Follow @anshi_makeover_ujjain
          </a>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
          {GALLERY.map((src, i) => (
            <Reveal key={src} delay={(i % 6) * 60}>
              <div
                data-testid={`gallery-item-${i}`}
                className="gallery-frame aspect-[3/4] relative group"
              >
                <img
                  src={src}
                  alt={`Anshi's Makeover work ${i + 1}`}
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#2a1b18]/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end p-4">
                  <div className="flex items-center gap-1.5 text-white text-xs font-medium">
                    <Heart size={12} fill="currentColor" />
                    Anshi's Makeover
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
